import React from 'react'
import StaticPageIcon from '../../../assets/static-pages-icon.png'
import CustomPageIcon from '../../../assets/custom-pages-icon.png'
import { useHistory } from 'react-router-dom'

const btnStyles = {
  width: 'max(8.4vw, 100px)',
  height: 'max(8.4vw, 100px)',
  borderRadius: '30px',
  background: 'linear-gradient(rgb(18, 194, 233), rgb(2, 0, 36))',
  justifyContent: 'space-around',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  paddingTop: '15px',
  border: 'none',
  outline: 'none',
}
const CustomPages = () => {
  const history = useHistory()

  const pagesObjArr = [
    {
      route: '/static-pages',
      img: StaticPageIcon,
      text: 'Static Pages',
    },
    {
      route: '/custom-pages',
      img: CustomPageIcon,
      text: 'Custom Pages',
    },
  ]

  return (
    <div>
      <h1 style={{ marginTop: '30px', color: '#191818', fontSize: '30px', fontWeight: 'bolder' }}>
        Make a Webpage as per your Choice !
      </h1>
      <p style={{ color: '#000' }}>Select the page type to create and/or edit </p>
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ gap: '0 6vw', marginTop: 'max(10vw,220px)' }}
      >
        {pagesObjArr.map((page, idx) => (
          <button
            style={btnStyles}
            className="hover-shadow hover-semibold"
            onClick={() => history.push(page.route)}
            key={idx}
          >
            <img src={page.img} alt="" style={{ width: '64%' }} />
            <p className="text-white">{page.text}</p>
          </button>
        ))}
      </div>
      {/* <StaticPageListing /> */}
    </div>
  )
}

export default CustomPages
